/// JTF3-added-AB-22-05-12

'use strict'

// jQuery(document).ready(function($) {
// 	// console.log('JTF Main Theme Script Loaded V2.2.11');
// });
